import { pathOr } from 'ramda';

import { PAGE_SUCCESS } from 'store/app/actions';

import { types } from './actions';
import { MODES } from './constants';

const initialState = {
  isLoading: false,
  isOpen: false,
  isSaving: false,
  mode: MODES.CREATE,
  workflow: null,
  workflowId: null,
  workSteps: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_SUCCESS:
      return {
        ...initialState,
      };
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.OPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isOpen: false,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        workflowId: pathOr(null, ['workflowId'], payload),
        isLoading: true,
        isOpen: true,
        mode: pathOr(MODES.CREATE, ['mode'], payload),
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        workflow: pathOr(null, ['workflow'], payload),
        isLoading: false,
        workSteps: payload.workSteps,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return {
        ...state,
        isSaving: false,
        isOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.workflows.workflowModal;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getMode = (state) => getScope(state).mode;

export const getWorkflow = (state) => getScope(state).workflow;

export const getWorkflowId = (state) => getScope(state).workflowId;

export const getWorkSteps = (state) => getScope(state).workSteps;
